module.exports = __webpack_public_path__ + "img/exclamation-circle-fill.93cf9539.svg";